exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#mobileViewOverlay .ProductCategoriesList_productCategories__QPqut{padding-top:10px;padding-bottom:10px;border-bottom:1px solid #e7e6e6}#mobileViewOverlay .ProductCategoriesList_productCategories__QPqut .ProductCategoriesList_productCategories__title__3bdOw{padding-left:15px;margin-bottom:5px;font-size:12px;color:#9fa0a4}#mobileViewOverlay .ProductCategoriesList_productCategories__QPqut .ProductCategoriesList_productCategories__list__1Te4j{visibility:visible}#GlobalSearchApp .ProductCategoriesList_productCategories__QPqut{padding-top:10px;padding-bottom:10px;border-bottom:1px solid #e7e6e6}#GlobalSearchApp .ProductCategoriesList_productCategories__QPqut .ProductCategoriesList_productCategories__title__3bdOw{padding-left:15px;margin-bottom:5px;font-size:12px;color:#9fa0a4}#GlobalSearchApp .ProductCategoriesList_productCategories__QPqut .ProductCategoriesList_productCategories__list__1Te4j{visibility:visible}@media only screen and (min-width:961px){#GlobalSearchApp .ProductCategoriesList_productCategories__QPqut .ProductCategoriesList_productCategories__title__3bdOw{padding-left:10px}}", ""]);

// exports
exports.locals = {
	"greenLight": "#79ff88",
	"greenMain": "#3dcd58",
	"greenDark": "#009530",
	"blueLight": "#7fe6ff",
	"blueMain": "#42b4e6",
	"blueDark": "#0084b4",
	"errorLight": "#ff5a36",
	"errorMain": "#b10043",
	"errorDark": "#c20000",
	"textBlack": "#333333",
	"textGray": "#9b9b9b",
	"textWhite": "#ffffff",
	"grayLight": "#9fa0a4",
	"grayBorder": "#e7e6e6",
	"containerWidthMain": "960",
	"heightDesktopHeader": "136px",
	"productCategories": "ProductCategoriesList_productCategories__QPqut",
	"productCategories__title": "ProductCategoriesList_productCategories__title__3bdOw",
	"productCategories__list": "ProductCategoriesList_productCategories__list__1Te4j"
};